import lrAIChatBox from './_src/lrAIChatBox.vue'

lrAIChatBox.install = function(Vue) {
  Vue.component(lrAIChatBox.name, lrAIChatBox)
}

export default lrAIChatBox